import React, { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import AgoraRTC from "agora-rtc-sdk-ng";
import deviceProfile from "images/device.png";
import CheckIcon from "@mui/icons-material/CheckRounded";
import XIcon from "@mui/icons-material/CloseRounded";
import PhoneCallIcon from "@mui/icons-material/PhoneRounded";
import EditIcon from "@mui/icons-material/EditRounded";
import { KeyboardVoiceRounded, MicOffRounded, VideocamRounded, VideocamOffRounded, } from "@mui/icons-material";
import RemindersTab from "js/UserBoard/ManageDevice/UserSettings/Tabs/reminders";
import CheckInsTab from "js/UserBoard/ManageDevice/UserSettings/Tabs/checkIn";
import WorkerHistoryTab from "js/UserBoard/ManageDevice/UserSettings/Tabs/workerHistory";
import ResetDevice from "js/UserBoard/ManageDevice/UserSettings/Tabs/resetDevice";
import ContactsTab from "./Tabs/contacts";
import InvitedUsers from "./Tabs/InvitedUsers";
import CaseNotesTab from "./Tabs/caseNotes";
import CallTranscriptsTab from "./Tabs/callTranscripts";
import DeviceForms from "./Tabs/DeviceForms";
import DeviceSettings from "./Tabs/DeviceSettings";
import KonnektForms from "./Tabs/KonnektForms";
import {
    fetchLinkedDevices as fetchLinkedDevicesApi,
    fetchDevice,
    updateDeviceName,
    updateDeviceAvatarAndAccountName,
    updateKonnectID,
} from "js/Api/index";
import ContentCopy from "@mui/icons-material/ContentCopy";
import TranslationTab from "./Tabs/translation";
import EditProfilePicModal from "./editProfilePicModal";
import { hasValue } from '../../../helpers/common_functions'

function UserSetting({ user, userInfo, onBackClick, onApplyToAllDevices, onApplyToThisDevice, settingsFrom, selectedOrg, fetchCwUsers, setSelectedUser, initialTab, }) {
    const [selectedTab, setSelectedTab] = useState(initialTab || "Contacts");
    const [refreshKey, setRefreshKey] = useState(0);
    const [linkedDevices, setLinkedDevices] = useState([]);
    const [reload_invite, setreload_inviteUpdate] = useState(false);
    const [isEditingName, setIsEditingName] = useState(false);
    const [newName, setNewName] = useState(user.name);
    const fileInputRef = useRef(null);
    const [showRenameModal, setShowRenameModal] = useState(false);
    const [showUpdateAvatarModal, setShowUpdateAvatarModal] = useState(false);
    const [selectedImageFile, setSelectedImageFile] = useState(null);
    const [isFamilyorg, setisFamilyorg] = useState(selectedOrg?.orgType === "family" ? true : false);

    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [previewVideoTrack, setPreviewVideoTrack] = useState(null);
    const [previewAudioTrack, setPreviewAudioTrack] = useState(null);
    const [isPreviewCameraEnabled, setIsPreviewCameraEnabled] = useState(true);
    const [isPreviewMicrophoneEnabled, setIsPreviewMicrophoneEnabled] =
        useState(true);
    const previewVideoRef = useRef(null);
    const [audioInputDevices, setAudioInputDevices] = useState([]);
    const [audioOutputDevices, setAudioOutputDevices] = useState([]);
    const [videoDevices, setVideoDevices] = useState([]);
    const [selectedAudioInput, setSelectedAudioInput] = useState("");
    const [selectedAudioOutput, setSelectedAudioOutput] = useState("");
    const [selectedCamera, setSelectedCamera] = useState("");
    const [isKonnektOrg, setisKonnektOrg] = useState(null);
    const [isEditDeviceModalVisible, setIsEditDeviceModalVisible] = useState(false)

    const [showTranscriptionModal, setShowTranscriptionModal] = useState(false); // open transcription modal for permission for transcription
    const [useTranscription, setUseTranscription] = useState(false); // use transcription or not in call
    const userProfileInfo = JSON.parse(localStorage.getItem("userInfo"));

    const afterResetRefreshAllTabs = () => {
    setSelectedTab("Contacts");
    setRefreshKey((k) => k + 1);
     };

    useEffect(() => {
        if (initialTab) {
            setSelectedTab(initialTab);
        }
    }, [initialTab]);

    useEffect(() => {
        setisKonnektOrg(false);
        if (selectedOrg?.code === "konnekt") {
            setisKonnektOrg(true);
        }
    }, [selectedOrg]);

    const cleanupPreviewTracks = async () => {
        if (previewVideoTrack) {
            previewVideoTrack.stop();
            previewVideoTrack.close();
            setPreviewVideoTrack(null);
        }
        if (previewAudioTrack) {
            previewAudioTrack.stop();
            previewAudioTrack.close();
            setPreviewAudioTrack(null);
        }
    };
    const filterDevices = (devices) => {
        return devices
            .filter(
                (device, index, self) =>
                    index === self.findIndex((d) => d.groupId === device.groupId)
            )
            .map((device) => ({
                deviceId: device.deviceId,
                ...device,
                label: device.label
                    .replace(/default|communications/gi, "")
                    .replace(/-/g, "")
                    .trim(),
            }));
    };

    const handleCallClick = async (user) => {
        setShowPreviewModal(true);
        setIsPreviewCameraEnabled(true);
        setIsPreviewMicrophoneEnabled(true);

        try {
            // console.log("[Preview] Requesting media permissions...");
            await navigator.mediaDevices.getUserMedia({ audio: true, video: true });

            // console.log("[Preview] Getting device lists...");
            const [audioDevices, audioOutput, cameraDevices] = await Promise.all([
                AgoraRTC.getMicrophones(),
                AgoraRTC.getPlaybackDevices(),
                AgoraRTC.getCameras(),
            ]);

            // console.log("[Preview] Raw devices:", {
            //   audioDevices,
            //   audioOutput,
            //   cameraDevices,
            // });

            const filteredAudio = filterDevices(audioDevices);
            const filteredOutput = filterDevices(audioOutput);
            const filteredVideo = filterDevices(cameraDevices);

            console.log("[Preview] Filtered devices:", {
                filteredAudio,
                filteredOutput,
                filteredVideo,
            });

            setAudioInputDevices(filteredAudio);
            setAudioOutputDevices(filteredOutput);
            setVideoDevices(filteredVideo);

            if (!selectedAudioInput && filteredAudio.length > 0) {
                // console.log("[Preview] Setting default audio input:", filteredAudio[0]);
                setSelectedAudioInput(filteredAudio[0].deviceId);
            }
            if (!selectedCamera && filteredVideo.length > 0) {
                // console.log("[Preview] Setting default camera:", filteredVideo[0]);
                setSelectedCamera(filteredVideo[0].deviceId);
            }

            // console.log("[Preview] Cleaning up previous tracks...");
            await cleanupPreviewTracks();

            // console.log("[Preview] Creating audio track with:", selectedAudioInput);
            const audioTrack = await AgoraRTC.createMicrophoneAudioTrack({
                microphoneId: selectedAudioInput || undefined,
            });

            // console.log("[Preview] Creating video track with:", selectedCamera);
            const videoTrack = await AgoraRTC.createCameraVideoTrack({
                encoderConfig: { width: 640, height: 360, frameRate: 15 },
                cameraId: selectedCamera || undefined,
            });

            setPreviewAudioTrack(audioTrack);
            setPreviewVideoTrack(videoTrack);

            // console.log("[Preview] Attempting to play video track...");
            if (previewVideoRef.current) {
                videoTrack.play(previewVideoRef.current);
                // console.log("[Preview] Video playback attached.");
            } else {
                console.warn("[Preview] previewVideoRef is null.");
            }
        } catch (error) {
            console.error("[Preview] Failed to create preview tracks", error);
            setIsPreviewCameraEnabled(false);
            setIsPreviewMicrophoneEnabled(false);
            toast.error("Failed to access camera or microphone.");
        }
    };

    const handleDeviceChange = (event, setter) => {
        setter(event.target.value);
    };

    const handleStartCall = async () => {
        setShowPreviewModal(false);
        cleanupPreviewTracks();

        const callData = {
            userInfo,
            callingDeviceId: user.id,
            callingAccountId: user.accountId,
            callerName: user.name,
            initialCameraEnabled: isPreviewCameraEnabled,
            initialMicrophoneEnabled: isPreviewMicrophoneEnabled,
            initialAudio: selectedAudioInput,
            initialVideo: selectedCamera,
            initialAudioOutput: selectedAudioOutput,
            answerName: user.name,
            devicePreferredLang: user.preferredLang,
        };

        if (useTranscription) {
            callData.isTranscriptionEnabled = useTranscription // Boolean value
        }

        const encodedCallData = btoa(JSON.stringify(callData));
        const videoCallTab = window.open(
            `/video-call?data=${encodedCallData}`,
            "_blank"
        );

        if (videoCallTab) {
            videoCallTab.focus();
        } else {
            toast.error(
                "Unable to open video call tab. Please check your popup blocker settings."
            );
        }
    };

    const handlePreviewCancel = async () => {
        setShowPreviewModal(false);
        await cleanupPreviewTracks();
    };

    const togglePreviewCamera = async () => {
        if (previewVideoTrack) {
            await previewVideoTrack.setEnabled(!isPreviewCameraEnabled);
            setIsPreviewCameraEnabled(!isPreviewCameraEnabled);
        }
    };

    const togglePreviewMicrophone = async () => {
        if (previewAudioTrack) {
            await previewAudioTrack.setEnabled(!isPreviewMicrophoneEnabled);
            setIsPreviewMicrophoneEnabled(!isPreviewMicrophoneEnabled);
        }
    };

    const fetchLinkedDevices = async () => {
        const result = await fetchLinkedDevicesApi(user.id);

        if (result.success) {
            const filteredData = result.data.filter(
                (device) => device.id !== user.id
            );
            setLinkedDevices(filteredData);
        } else {
            console.log("Failed to fetch linked devices:", result.error);
        }
    };

    const refreshDeviceInfo = async () => {
        const result = await fetchDevice(user.id);

        if (result.success) {
            if (fetchCwUsers) fetchCwUsers();
            setSelectedUser(result.data);
        } else {
            console.error("Failed to refresh device info:", result.error);
            toast.error("Failed to refresh device information");
        }
    };

    const handleNameEdit = () => {
        setIsEditingName(true);
    };

    //#region Konnekt

    const [showRenameKonnectIdModal, setshowRenameKonnectIdModal] =
        useState(false);
    const [isEditingKonnektId, setisEditingKonnektId] = useState(false);
    const [newKonnektId, setnewKonnektId] = useState(user?.konnektDeviceId);

    const handleEditKonnectId = () => {
        setisEditingKonnektId(true);
    };

    const handleCancelEditKonnectId = () => {
        setnewKonnektId(user?.konnektDeviceId);
        setisEditingKonnektId(false);
    };

    const handleKonnectIdSubmitClick = () => {
        setshowRenameKonnectIdModal(true);
    };

    const handleRenameKonnktIdConfirm = async () => {
        await handleKonnektIDSubmit();
        setisEditingKonnektId(false);
        setshowRenameKonnectIdModal(false);
    };

    const handleKonnektIDSubmit = async () => {
        const result = await updateKonnectID(user.id, newKonnektId);

        if (result.success) {
            setIsEditingName(false);
            await refreshDeviceInfo();
        } else {
            toast.error(result.error || "Failed to update name");
        }
    };

    const setreload_invite = (value) => {
        setreload_inviteUpdate(prev => !prev)
        setSelectedTab("InvitedUsers")
    }

    //#endregion

    const handleNameSubmit = async () => {
        const result = await updateDeviceName(user.id, newName);

        if (result.success) {
            setIsEditingName(false);
            toast.success(result.message);
            await refreshDeviceInfo();
        } else {
            toast.error(result.error || "Failed to update name");
        }
    };

    const handleNameSubmitClick = () => {
        setShowRenameModal(true);
    };

    const handleCancelEdit = () => {
        setNewName(user.name);
        setIsEditingName(false);
    };

    const handleRenameConfirm = async () => {
        await handleNameSubmit();
        setShowRenameModal(false);
    };

    const handlePhotoEdit = () => {
        setIsEditDeviceModalVisible(true)
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedImageFile(file);
            setShowUpdateAvatarModal(true);
        }
    };

    const handleCancelAvatar = () => {
        setShowUpdateAvatarModal(false);
        setSelectedImageFile(null);

        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const handleConfirmAvatarUpdate = async () => {
        if (selectedImageFile) {
            const result = await updateDeviceAvatarAndAccountName(user.id, selectedImageFile,);

            if (result.success) {
                toast.success(result.message);
                await refreshDeviceInfo();
            } else {
                toast.error(result.error);
            }
        }

        setShowUpdateAvatarModal(false);
        setSelectedImageFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const buttonStyle = (enabled) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "60px",
        height: "60px",
        margin: "0 10px",
        borderRadius: "50%",
        border: "none",
        cursor: "pointer",
        transition: "all 0.3s ease",
        backgroundColor: enabled ? "#1976D2" : "#1976D2",
        boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
        color: "white",
    });

    const [openInviteModel, setopenInviteModel] = useState(false);
    const OpneInviteModel = () => {
        setSelectedTab("InvitedUsers");
        setopenInviteModel(true);
    };

    const onCloseEditProfileModalHandler = () => {
        setIsEditDeviceModalVisible(false)
    }

    // Transcription modal close
    const handleApplyModelCancel = () => {
        setShowTranscriptionModal(false);
        handleCallClick(user);
    };

    // Do yes for on transcription
    const handleUseTheTranslatorBtn = () => {
        setShowTranscriptionModal(false);
        handleCallClick(user);
        setUseTranscription(true);
    };

    // Show transcription modal
    const handlePreferrenceBeheviour = () => {
        setShowTranscriptionModal(true);
    };

    const LoadSettingUI = ({ tabName, selTab }) => {
        return (
            <div className={`nav-item nav-link ${selectedTab === selTab ? "active" : ""}`} onClick={() => setSelectedTab(selTab)} >
                {tabName}
            </div>
        );
    }

    return (
        <div>
            {isKonnektOrg !== null && (
                <>
                    <div className="white_shd full margin_bottom_30" style={{ paddingLeft: "10px", paddingRight: "10px" }} >
                        <div style={{ display: "flex", marginTop: "40px", marginLeft: "40px" }} >
                            <div style={{ position: "relative", display: "inline-block" }}>
                                {user.profilePicture ? (
                                    <img className="imgUserProfilePic" style={{ display: "block" }} src={`data:image/png;base64, ${user.profilePicture}`} alt={user.name} />
                                ) : (
                                    <img className="imgUserProfilePic" style={{ display: "block" }} src={deviceProfile} alt="Default profile" />
                                )}
                                <div onClick={handlePhotoEdit} style={{
                                    position: "absolute", transform: "translate(400%, -100%)", cursor: "pointer", background: "#fff", borderRadius: "50%",
                                    padding: "4px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                }} >
                                    <EditIcon sx={{ fontSize: "1.2rem", color: "black" }} />
                                </div>
                                <input type="file" ref={fileInputRef} onChange={handleFileChange} style={{ display: "none" }} accept="image/*" />
                            </div>

                            <div
                                style={{
                                    marginLeft: "12px",
                                    marginTop: "60px",
                                    marginBottom: "30px",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "20px",
                                }}
                            >
                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }} >
                                    {isEditingName ? (
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px", }} >
                                            <input
                                                type="text"
                                                value={newName}
                                                onChange={(e) => setNewName(e.target.value)}
                                                style={{
                                                    border: "none",
                                                    borderBottom: "1px solid #ddd",
                                                    fontSize: "24px",
                                                    padding: "0 4px",
                                                    outline: "none",
                                                }}
                                            />
                                            <div style={{ display: "flex", gap: "8px" }}>
                                                <div
                                                    onClick={handleNameSubmitClick}
                                                    style={{ cursor: "pointer", color: "#4CAF50" }}
                                                >
                                                    <CheckIcon sx={{ fontSize: "1.2rem" }} />
                                                </div>
                                                <div
                                                    onClick={handleCancelEdit}
                                                    style={{ cursor: "pointer", color: "#FF5252" }}
                                                >
                                                    <XIcon sx={{ fontSize: "1.2rem" }} />
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <h2 style={{ margin: 0 }}>{user.name}</h2>
                                            <div
                                                onClick={handleNameEdit}
                                                style={{
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    color: "#000",
                                                }}
                                            >
                                                <EditIcon sx={{ fontSize: "1.2rem" }} />
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "auto minmax(200px, 1fr) auto",
                                        alignItems: "center",
                                        width: "100%",
                                    }}
                                >
                                    {isKonnektOrg ? (
                                        <>
                                            <p>
                                                Videophone Profile Name :
                                                {isEditingKonnektId ? (
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px",
                                                        }}
                                                    >
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            value={newKonnektId}
                                                            onChange={(e) => setnewKonnektId(e.target.value)}
                                                            style={{
                                                                border: "none",
                                                                borderBottom: "1px solid #ddd",
                                                                outline: "none",
                                                            }}
                                                        />
                                                        <div style={{ display: "flex", gap: "8px" }}>
                                                            <div
                                                                onClick={handleKonnectIdSubmitClick}
                                                                style={{ cursor: "pointer", color: "#4CAF50" }}
                                                            >
                                                                <CheckIcon sx={{ fontSize: "1.2rem" }} />
                                                            </div>
                                                            <div
                                                                onClick={handleCancelEditKonnectId}
                                                                style={{ cursor: "pointer", color: "#FF5252" }}
                                                            >
                                                                <XIcon sx={{ fontSize: "1.2rem" }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <>
                                                        {user?.konnektDeviceId}&nbsp;&nbsp;&nbsp;
                                                        <EditIcon
                                                            onClick={() => {
                                                                handleEditKonnectId();
                                                            }}
                                                            sx={{
                                                                color: "black",
                                                                marginRight: "10px",
                                                                cursor: "pointer",
                                                            }}
                                                        />
                                                        &nbsp;&nbsp;&nbsp;
                                                        <ContentCopy
                                                            onClick={() => {
                                                                toast.success('Copied');
                                                                navigator.clipboard.writeText(
                                                                    user?.konnektDeviceId
                                                                );
                                                            }}
                                                            sx={{
                                                                color: "black",
                                                                marginRight: "10px",
                                                                cursor: "pointer",
                                                            }}
                                                        />
                                                        <br />
                                                        Care Window Device Id : {user?.id}
                                                    </>
                                                )}
                                            </p>
                                        </>
                                    ) : <>
                                        <p style={{ fontWeight: "700", color: "black", margin: 0, gridColumn: "1", }} >

                                            {!isFamilyorg &&
                                                <span class="bg-light text-dark border fw-normal py-2 px-3">
                                                    <strong>Device Id:</strong> <span class="text-muted ms-1">{user?.id ? user.id : "Unknown"}</span>
                                                    {hasValue(user.id) &&
                                                        <ContentCopy onClick={() => {
                                                            toast.success('Copied');
                                                            navigator.clipboard.writeText(
                                                                user.id
                                                            );
                                                        }} sx={{ marginLeft: "5px", cursor: "pointer", fontSize: "1rem" }} />
                                                    }
                                                </span>
                                            }

                                            <span class="bg-light text-dark border fw-normal py-2 px-3">
                                                <strong>S/N:</strong> <span class="text-muted ms-1">{user.serialNo ? user.serialNo : "Unknown"}</span>
                                                {hasValue(user.serialNo) &&
                                                    <ContentCopy onClick={() => {
                                                        toast.success('Copied');
                                                        navigator.clipboard.writeText(
                                                            user.serialNo
                                                        );
                                                    }} sx={{ marginLeft: "5px", cursor: "pointer", fontSize: "1rem" }} />
                                                }
                                            </span>
                                            <span class="bg-light text-dark border fw-normal py-2 px-3">
                                                <strong>App Version:</strong> <span class="text-muted ms-1">{user.apP_Version ? user.apP_Version : "Unknown"}</span>
                                            </span>

                                            {!isFamilyorg &&
                                                <>
                                                    <span class="bg-light text-dark border fw-normal py-2 px-3">
                                                        <strong>Mac Address:</strong> <span class="text-muted ms-1">{user.macAddress ? user.macAddress : "Unknown"}</span>
                                                        {hasValue(user.macAddress) &&
                                                            <ContentCopy onClick={() => {
                                                                toast.success('Copied');
                                                                navigator.clipboard.writeText(
                                                                    user.macAddress
                                                                );
                                                            }} sx={{ marginLeft: "5px", cursor: "pointer", fontSize: "1rem" }} />
                                                        }
                                                    </span>
                                                    {user.deviceType === "android-carewindow" && (
                                                        <span class="bg-light text-dark border fw-normal py-2 px-3">
                                                            <strong>Phone number:</strong>{" "}
                                                            <span class="text-muted ms-1">
                                                                {Array.isArray(user.sipPhoneNumbers) && user.sipPhoneNumbers.length > 0
                                                                    ? user.sipPhoneNumbers[0]
                                                                    : "Not set"}
                                                            </span>
                                                            {Array.isArray(user.sipPhoneNumbers) && user.sipPhoneNumbers.length > 0 && (
                                                                <ContentCopy onClick={() => {
                                                                    toast.success('Copied');
                                                                    navigator.clipboard.writeText(user.sipPhoneNumbers[0]);
                                                                }} sx={{ marginLeft: "5px", cursor: "pointer", fontSize: "1rem" }} />
                                                            )}
                                                        </span>
                                                    )}
                                                    {hasValue(user?.policyName) &&
                                                        <>
                                                            <span class="bg-light text-dark border fw-normal py-2 px-3">
                                                                <a style={{ textDecoration: "underline", cursor: "pointer", color: "#007bff" }} target="_blank" href={`/userboard/${selectedOrg.id}#device_groups#id=${user.policyId}`}>
                                                                    <strong>Policy Name:</strong> {user?.policyName}
                                                                </a>
                                                            </span>
                                                        </>
                                                    }
                                                </>
                                            }
                                        </p>
                                    </>
                                    }
                                    <div style={{ gridColumn: "2" }} /> {/* 中间空白区域 */}
                                    <button
                                        className="btn btn-success"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "5px",
                                            padding: "6px 30px",
                                            gridColumn: "3",
                                            justifySelf: "end",
                                        }}
                                        onClick={() => {
                                            if (userProfileInfo.translateBehaviour === "askEachTime") {
                                                handlePreferrenceBeheviour(); // Show transcription modal
                                            } else {
                                                handleCallClick(user);
                                            }

                                        }}
                                    >
                                        <PhoneCallIcon sx={{ fontSize: "1.2rem" }} />
                                        Call
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="full inner_elements">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="tab_style1">
                                        <div
                                            className="tabbar padding_infor_info"
                                            style={{ display: "block", paddingTop: "25px" }}
                                        >
                                            <nav>
                                                <div className="nav nav-tabs" id="nav-tab" role="tablist" >
                                                    <LoadSettingUI tabName="Contacts" selTab="Contacts" />

                                                    {isKonnektOrg ? (
                                                        <>
                                                            <LoadSettingUI tabName="Invited Users" selTab="InvitedUsers" />
                                                            <LoadSettingUI tabName="Build Form" selTab="KonnektForms" />
                                                        </>
                                                    ) :
                                                        <>
                                                            {!isFamilyorg && <LoadSettingUI tabName="Case Notes" selTab="CaseNotes" />}
                                                            <LoadSettingUI tabName="Device Settings" selTab="device_settings" />
                                                            <LoadSettingUI tabName="Reminders" selTab="Reminders" />
                                                            {!isFamilyorg && <LoadSettingUI tabName="Forms" selTab="Forms" />}
                                                            <LoadSettingUI tabName="Wellness Check" selTab="WellnessCheck" />
                                                            <LoadSettingUI tabName={isFamilyorg ? "Visitor Book" : "Worker History"} selTab="WorkerHistory" />
                                                            {/* {!isFamilyorg && <LoadSettingUI tabName="Translation" selTab="Translation" />} */}
                                                            <LoadSettingUI tabName="Call Logs" selTab="CallTranscripts" />
                                                            <LoadSettingUI tabName="Reset Device" selTab="ResetDevice" />
                                                        </>
                                                    }
                                                </div>
                                            </nav>
                                            <div className="tab-content" id="nav-tabContent">
                                                <div
                                                    className={`tab-pane fade ${selectedTab === "Contacts" ? "show active" : ""
                                                        }`}
                                                    id="nav-contacts"
                                                    role="tabpanel"
                                                >
                                                    <ContactsTab
                                                        key={`contacts-${refreshKey}`}
                                                        user={user}
                                                        setreload_invite={setreload_invite}
                                                        fetchLinkedDevices={fetchLinkedDevices}
                                                        linkedDevices={linkedDevices}
                                                        setLinkedDevices={setLinkedDevices}
                                                        selectedOrg={selectedOrg}
                                                        OpneInviteModel={OpneInviteModel}
                                                    />
                                                </div>
                                                {isKonnektOrg ? (
                                                    <>
                                                        <div
                                                            className={`tab-pane fade ${selectedTab === "InvitedUsers"
                                                                ? "show active"
                                                                : ""
                                                                }`}
                                                            id="nav-contacts"
                                                            role="tabpanel"
                                                        >
                                                            <InvitedUsers reload_invite={reload_invite}
                                                                key={`invited-${refreshKey}`}
                                                                user={user}
                                                                openInviteModel={openInviteModel}
                                                            />
                                                        </div>
                                                        <div className={`tab-pane fade ${selectedTab === "KonnektForms" ? "show active" : ""}`} id="nav-KonnektForms" role="KonnektFormsPanel" >
                                                            <KonnektForms user={user} />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div
                                                            className={`tab-pane fade ${selectedTab === "Reminders" ? "show active" : ""
                                                                }`}
                                                            id="nav-reminders"
                                                            role="tabpanel"
                                                            aria-labelledby="nav-reminders-tab"
                                                        >
                                                            <RemindersTab
                                                                key={`reminders-${refreshKey}`}
                                                                user={user}
                                                                onApplyToAllDevices={onApplyToAllDevices}
                                                                onApplyToThisDevice={onApplyToThisDevice}
                                                                settingsFrom={settingsFrom}
                                                            />
                                                        </div>
                                                        {!isFamilyorg &&
                                                            <div
                                                                className={`tab-pane fade ${selectedTab === "Forms" ? "show active" : ""
                                                                    }`}
                                                                id="nav-reminders"
                                                                role="tabpanel"
                                                                aria-labelledby="nav-reminders-tab"
                                                            >
                                                                <DeviceForms key={`forms-${refreshKey}`} user={user} />
                                                            </div>
                                                        }
                                                        <div className={`tab-pane fade ${selectedTab === "device_settings" ? "show active" : ""}`}
                                                            role="tabpanel" aria-labelledby="nav-reminders-tab" >
                                                            <DeviceSettings key={`device_settings-${refreshKey}`} device={user} isFamilyorg={isFamilyorg} />
                                                        </div>
                                                        {!isFamilyorg &&
                                                            <div
                                                                className={`tab-pane fade ${selectedTab === "CaseNotes" ? "show active" : ""
                                                                    }`}
                                                                id="nav-case-notes"
                                                                role="tabpanel"
                                                                aria-labelledby="nav-case-notes-tab"
                                                            >
                                                                <CaseNotesTab
                                                                    key={`casenotes-${refreshKey}`}
                                                                    user={user}
                                                                    onApplyToAllDevices={onApplyToAllDevices}
                                                                    onApplyToThisDevice={onApplyToThisDevice}
                                                                    settingsFrom={settingsFrom}
                                                                />
                                                            </div>
                                                        }

                                                        <div
                                                            className={`tab-pane fade ${selectedTab === "WellnessCheck"
                                                                ? "show active"
                                                                : ""
                                                                }`}
                                                            id="nav-wellnesscheck"
                                                            role="tabpanel"
                                                            aria-labelledby="nav-wellnesscheck-tab"
                                                        >
                                                            <CheckInsTab
                                                                key={`wellness-${refreshKey}`}
                                                                user={user}
                                                                userInfo={userInfo}
                                                                onApplyToAllDevices={onApplyToAllDevices}
                                                                onApplyToThisDevice={onApplyToThisDevice}
                                                                settingsFrom={settingsFrom}
                                                            />
                                                        </div>

                                                        <div
                                                            className={`tab-pane fade ${selectedTab === "WorkerHistory"
                                                                ? "show active"
                                                                : ""
                                                                }`}
                                                            id="nav-workerhitory"
                                                            role="tabpanel"
                                                            aria-labelledby="nav-workerhitory-tab"
                                                        >
                                                            <WorkerHistoryTab
                                                                key={`workerhistory-${refreshKey}`}
                                                                user={user} isFamilyorg={isFamilyorg}
                                                                onApplyToAllDevices={onApplyToAllDevices}
                                                                onApplyToThisDevice={onApplyToThisDevice}
                                                                settingsFrom={settingsFrom}
                                                            />
                                                        </div>



                                                        {/* <div
                                                            className={`tab-pane fade ${selectedTab === "Translation"
                                                                ? "show active"
                                                                : ""
                                                                }`}
                                                            id="nav-workerhitory"
                                                            role="tabpanel"
                                                            aria-labelledby="nav-workerhitory-tab"
                                                        >
                                                            <TranslationTab
                                                                user={user}
                                                                onApplyToAllDevices={onApplyToAllDevices}
                                                                onApplyToThisDevice={onApplyToThisDevice}
                                                                settingsFrom={settingsFrom}
                                                                refreshDeviceInfo={refreshDeviceInfo}
                                                            />
                                                        </div> */}

                                                        <div
                                                            className={`tab-pane fade ${selectedTab === "CallTranscripts"
                                                                ? "show active"
                                                                : ""
                                                                }`}
                                                            id="nav-transcripts"
                                                            role="tabpanel"
                                                            aria-labelledby="nav-transcripts-tab"
                                                        >
                                                            <CallTranscriptsTab
                                                                key={`calltranscripts-${refreshKey}`}
                                                                user={user}
                                                                userInfo={userInfo}
                                                                onApplyToAllDevices={onApplyToAllDevices}
                                                                onApplyToThisDevice={onApplyToThisDevice}
                                                                settingsFrom={settingsFrom}
                                                            />
                                                        </div>

                                                        <div
                                                            className={`tab-pane fade ${selectedTab === "ResetDevice"
                                                                ? "show active"
                                                                : ""
                                                                }`}
                                                            id="nav-reset-device"
                                                            role="tabpanel"
                                                            aria-labelledby="nav-reset-device-tab"
                                                        >
                                                            <ResetDevice user={user} selectedOrg={selectedOrg} fetchCwUsers={fetchCwUsers} onBackClick={onBackClick} isFamilyorg={isFamilyorg}
                                                                refreshDeviceInfo={refreshDeviceInfo} setSelectedUser={setSelectedUser} onResetDone={afterResetRefreshAllTabs} />
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {showUpdateAvatarModal && (
                        <div className="modal" role="dialog">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content" style={{ width: "400px" }}>
                                    <div className="modal-header">
                                        <h1 className="modal-title">Update Profile Picture</h1>
                                        <button
                                            className="close-button"
                                            onClick={handleCancelAvatar}
                                        >
                                            &times;
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <p>Are you sure you want to update the profile picture?</p>
                                    </div>
                                    <div className="modal-footer">
                                        <button
                                            type="button"
                                            className="btn cur-p btn-secondary"
                                            onClick={handleCancelAvatar}
                                        >
                                            {" "}
                                            Cancel{" "}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn cur-p btn-primary"
                                            onClick={handleConfirmAvatarUpdate}
                                        >
                                            {" "}
                                            Update{" "}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {
                        showRenameModal && (
                            <div className="modal" role="dialog">
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content" style={{ width: "400px" }}>
                                        <div className="modal-header">
                                            <h1 className="modal-title">Rename Device</h1>
                                            <button
                                                className="close-button"
                                                onClick={() => setShowRenameModal(false)}
                                            >
                                                {" "}
                                                &times;{" "}
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <p>
                                                Are you sure you want to rename this device from '
                                                {user.name}' to '{newName}'?
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn cur-p btn-secondary"
                                                onClick={() => setShowRenameModal(false)}
                                            >
                                                {" "}
                                                Cancel{" "}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn cur-p btn-primary"
                                                onClick={handleRenameConfirm}
                                            >
                                                {" "}
                                                Rename{" "}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }

                    {
                        showRenameKonnectIdModal && (
                            <div className="modal" role="dialog">
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content" style={{ width: "400px" }}>
                                        <div className="modal-header">
                                            <h1 className="modal-title">Rename Konnekt Id</h1>
                                            <button
                                                className="close-button"
                                                onClick={() => setshowRenameKonnectIdModal(false)}
                                            >
                                                {" "}
                                                &times;{" "}
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <p>
                                                Are you sure you want to rename this device konnekt Id
                                                from '{user.konnektDeviceId}' to '{newKonnektId}'?
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn cur-p btn-secondary"
                                                onClick={() => setshowRenameKonnectIdModal(false)}
                                            >
                                                {" "}
                                                Cancel{" "}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn cur-p btn-primary"
                                                onClick={handleRenameKonnktIdConfirm}
                                            >
                                                {" "}
                                                Rename{" "}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    {
                        showPreviewModal && (
                            <div
                                className="modal fade show"
                                style={{
                                    display: "block",
                                    backgroundColor: "rgba(0,0,0,0.5)",
                                    overflowY: "auto",
                                    paddingBottom: "20px",
                                }}
                                aria-modal="true"
                                role="dialog"
                            >
                                <div
                                    className="modal-dialog modal-lg modal-dialog-centered"
                                    role="document"
                                    style={{ maxWidth: "90%", margin: "auto" }}
                                >
                                    <div
                                        className="modal-content"
                                        style={{
                                            backgroundColor: "#f0f0f0",
                                            width: "100%",
                                            padding: "15px",
                                            maxHeight: "90vh",
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <div className="modal-header" style={{ flexShrink: 0 }}>
                                            <h1 className="modal-title">Video Call Preview</h1>
                                            <button
                                                type="button"
                                                className="close-button"
                                                onClick={handlePreviewCancel}
                                                aria-label="Close"
                                                style={{
                                                    background: "none",
                                                    border: "none",
                                                    fontSize: "1.5rem",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div
                                            className="modal-body"
                                            style={{ padding: "15px", overflowY: "auto", flexGrow: 1 }}
                                        >
                                            <div
                                                style={{
                                                    width: "100%",
                                                    aspectRatio: "16/9",
                                                    backgroundColor: "black",
                                                    position: "relative",
                                                    borderRadius: "8px",
                                                    overflow: "hidden",
                                                }}
                                            >
                                                <div
                                                    ref={previewVideoRef}
                                                    style={{ width: "100%", height: "100%" }}
                                                />
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    marginTop: "15px",
                                                }}
                                            >
                                                <button
                                                    onClick={togglePreviewMicrophone}
                                                    style={buttonStyle(isPreviewMicrophoneEnabled)}
                                                >
                                                    {isPreviewMicrophoneEnabled ? (
                                                        <KeyboardVoiceRounded />
                                                    ) : (
                                                        <MicOffRounded />
                                                    )}
                                                </button>
                                                <button
                                                    onClick={togglePreviewCamera}
                                                    style={buttonStyle(isPreviewCameraEnabled)}
                                                >
                                                    {isPreviewCameraEnabled ? (
                                                        <VideocamRounded />
                                                    ) : (
                                                        <VideocamOffRounded />
                                                    )}
                                                </button>
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    marginTop: "15px",
                                                }}
                                            >
                                                {/* Microphone Selection */}
                                                <div
                                                    style={{
                                                        width: "100%",
                                                        maxWidth: "350px",
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    <label
                                                        htmlFor="audio-input-select"
                                                        style={{
                                                            display: "block",
                                                            marginBottom: "5px",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {" "}
                                                        Microphone{" "}
                                                    </label>
                                                    <select
                                                        id="audio-input-select"
                                                        value={selectedAudioInput}
                                                        onChange={(e) =>
                                                            handleDeviceChange(e, setSelectedAudioInput)
                                                        }
                                                        style={{
                                                            width: "100%",
                                                            padding: "8px",
                                                            borderRadius: "5px",
                                                            border: "1px solid #ccc",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        <option value="">
                                                            System Default -{" "}
                                                            {audioInputDevices[0]?.label || "No Device"}
                                                        </option>
                                                        {audioInputDevices.map((device) => (
                                                            <option
                                                                key={device.deviceId}
                                                                value={device.deviceId}
                                                            >
                                                                {device.label || "Unnamed Audio Input"}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                {/* Speaker Selection */}
                                                <div
                                                    style={{
                                                        width: "100%",
                                                        maxWidth: "350px",
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    <label
                                                        htmlFor="audio-output-select"
                                                        style={{
                                                            display: "block",
                                                            marginBottom: "5px",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {" "}
                                                        Speaker{" "}
                                                    </label>
                                                    <select
                                                        id="audio-output-select"
                                                        value={selectedAudioOutput}
                                                        onChange={(e) =>
                                                            handleDeviceChange(e, setSelectedAudioOutput)
                                                        }
                                                        style={{
                                                            width: "100%",
                                                            padding: "8px",
                                                            borderRadius: "5px",
                                                            border: "1px solid #ccc",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        <option value="">
                                                            System Default -{" "}
                                                            {audioOutputDevices[0]?.label || "No Device"}
                                                        </option>
                                                        {audioOutputDevices.map((device) => (
                                                            <option
                                                                key={device.deviceId}
                                                                value={device.deviceId}
                                                            >
                                                                {device.label || "Unnamed Audio Output"}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                {/* Camera Selection */}
                                                <div style={{ width: "100%", maxWidth: "350px" }}>
                                                    <label
                                                        htmlFor="camera-select"
                                                        style={{
                                                            display: "block",
                                                            marginBottom: "5px",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {" "}
                                                        Camera{" "}
                                                    </label>
                                                    <select
                                                        id="camera-select"
                                                        value={selectedCamera}
                                                        onChange={(e) =>
                                                            handleDeviceChange(e, setSelectedCamera)
                                                        }
                                                        style={{
                                                            width: "100%",
                                                            padding: "8px",
                                                            borderRadius: "5px",
                                                            border: "1px solid #ccc",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        <option value="">
                                                            System Default -{" "}
                                                            {videoDevices[0]?.label || "No Device"}
                                                        </option>
                                                        {videoDevices.map((device) => (
                                                            <option
                                                                key={device.deviceId}
                                                                value={device.deviceId}
                                                            >
                                                                {device.label || "Unnamed Camera"}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="modal-footer"
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                flexShrink: 0,
                                            }}
                                        >
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={handlePreviewCancel}
                                            >
                                                {" "}
                                                Cancel{" "}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={handleStartCall}
                                            >
                                                {" "}
                                                Start Call
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </>
            )}
            {
                showTranscriptionModal && (
                    <div className="modal" tabIndex={"-1"} role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content" style={{ width: "400px" }}>
                                <div className="modal-header">
                                    <h1 className="modal-title">Enable Translation?</h1>
                                    <button
                                        className="close-button"
                                        onClick={() => setShowTranscriptionModal(false)}
                                    >
                                        &times;
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <span>
                                        {user?.name} preferred language is {user?.preferredLang}, and
                                        your preferred language is {userInfo?.preferredLang}. Would
                                        you like to use the translator?
                                    </span>
                                </div>
                                <div className="modal-footer d-flex flex-column align-items-stretch">
                                    <div className="mb-2">
                                        <button
                                            className="btn cur-p btn-dark w-100"
                                            onClick={handleUseTheTranslatorBtn}
                                        >
                                            Yes, use the translator
                                        </button>
                                    </div>
                                    <div className="ml-0">
                                        <button
                                            className="btn cur-p btn-outline-dark w-100"
                                            onClick={handleApplyModelCancel}
                                        >
                                            Don’t use the translator
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            <EditProfilePicModal
                visible={isEditDeviceModalVisible}
                user={user}
                refreshDeviceInfo={refreshDeviceInfo}
                handleCancel={onCloseEditProfileModalHandler}
            />
        </div >
    );
}

export default UserSetting;